/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["*[_ngcontent-%COMP%],   *{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}"];
export { styles as styles };
